module.exports = __webpack_public_path__ + "static/artist-management-the-process-2290a1544abb741deb910aa3c354a826.png";